/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_Scheduled_DateInputs */

const en_task_reminders_scheduled_date = /** @type {(inputs: Task_Reminders_Scheduled_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled date`)
};

const pt_br2_task_reminders_scheduled_date = /** @type {(inputs: Task_Reminders_Scheduled_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de agendamento`)
};

/**
* | output |
* | --- |
* | "Scheduled date" |
*
* @param {Task_Reminders_Scheduled_DateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_scheduled_date = /** @type {((inputs?: Task_Reminders_Scheduled_DateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_Scheduled_DateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_scheduled_date(inputs)
	return pt_br2_task_reminders_scheduled_date(inputs)
});